var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebookCircle = function SvgFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20Zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18Zm-3.239-6.182h4.434V21.362h2.958l.393-3.602h-3.351l.006-1.804c0-.94.091-1.443 1.475-1.443h1.85V10.91h-2.96c-3.554 0-4.805 1.749-4.805 4.688v2.163h-2.215v3.602h2.215v10.456Z",
    fill: "#007A43"
  })));
};

export default SvgFacebookCircle;